import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 40px;
`;

export const Message = styled.p`
  font-size: 16px;
  color: #666;
`;
